<template>
    <div  v-if="$p('measurement/measurement')" class="play-button-form" v-loading="isLoading">

        <div class="play-button-header">
            <el-row>
                <el-col :span="12" class="play-button-label">{{$l('dashboard/measuringTgl')}}</el-col>
                <el-col :span="12" class="play-button-switch">
                     <el-switch  @change="onMeasuringChanged" v-model="measuringActive" on-text="" off-text=""></el-switch>
                    
                </el-col>
            </el-row>
        </div>
        <el-row class="play-button-row">
            <el-col :span="12" class="play-button-label">{{$l('dashboard/noiseTgl')}}</el-col>
            <el-col :span="12" class="play-button-switch">
                <el-switch v-show="!getStatus.noiseError" @change="onNoiseChanged" v-model="noiseActive" on-text="" off-text=""></el-switch>
                <el-switch v-show="getStatus.noiseError" on-color="#e43a45" @change="onNoiseChanged" v-model="noiseActive" on-text="" off-text=""></el-switch>
            </el-col>
        </el-row>
        <el-row class="play-button-row">
            <el-col :span="12" class="play-button-label">{{$l('dashboard/weatherTgl')}}</el-col>
            <el-col :span="12" class="play-button-switch">
                <el-switch v-show="!getStatus.weatherError" @change="onWeatherChanged" v-model="weatherActive" on-text="" off-text="">ja</el-switch>                
                <el-switch v-show="getStatus.weatherError" on-color="#e43a45" @change="onWeatherChanged" v-model="weatherActive" on-text="" off-text="">ne</el-switch>
            </el-col>
        </el-row>
        <el-row class="play-button-row">
            <el-col :span="12" class="play-button-label">{{$l('dashboard/adioTgl')}}</el-col>
            <el-col :span="12" class="play-button-switch">
                <el-switch v-show="!getStatus.adioError" @change="onAdioChanged" v-model="adioActive" on-text="" off-text="">ja</el-switch>                
                <el-switch v-show="getStatus.adioError" on-color="#e43a45" @change="onAdioChanged" v-model="adioActive" on-text="" off-text="">ne</el-switch>
            </el-col>
        </el-row>
    </div>
</template>

<style>
    .play-button-form{
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .play-button-header{
        padding-bottom: 5px;
        border-bottom:1px solid #e9edef ;
    }
    .play-button-label{
        padding-top: 2px;
        font-size: 14px;
        font-weight: 500;
    }
    .play-button-switch{
        text-align: right;
        font-size: 15px;
    }
    .play-button-row{
        margin-top: 10px;
    }
</style>


<script>
import { mapGetters } from 'vuex'
import {getStatus, startWeather, stopWeather, stopNoise, startNoise, stopAdio, startAdio, startAll, stopAll} from '@/store/actions';
export default {
    computed:{
        ...mapGetters([
            'getStatus'
        ]),
        noiseActive: function(){
            return (this.getStatus)?this.getStatus.noise:false;
        },
        weatherActive: function(){
            return (this.getStatus)?this.getStatus.weather:false;
        },
        adioActive: function(){
            return (this.getStatus)?this.getStatus.adio:false;
        },
        measuringActive: function(){
            return this.noiseActive && this.weatherActive && this.adioActive;
        },
        weatherOnColor:function(){
            return (this.getStatus.weatherError)?'#e43a45' : '#20A0FF';
        },
        noiseOnColor: function(){
            return (this.getStatus.noiseError)?'#e43a45' : '#20A0FF';            
        },
        adioOnColor: function(){
            return (this.getStatus.adioError)?'#e43a45' : '#20A0FF';   
        }
        
    },
    data(){
        return{
            test:true,
            getStatusLoop:undefined,
            isLoading:false,
        }
    },
    methods: {
        onWeatherChanged: function(){
            this.isLoading = true;
            if(this.weatherActive){
                stopWeather(this.$store)
                    .then(()=>{
                        this.isLoading = false;
                    });
            }else{
                startWeather(this.$store)
                    .then(()=>{
                        this.isLoading = false;
                    });
            }
        },
        onNoiseChanged: function(){
            this.isLoading = true;
            if(this.noiseActive){
                stopNoise(this.$store)
                    .then(()=>{
                        this.isLoading = false;
                    });
            }else{
                startNoise(this.$store)
                    .then(()=>{
                        this.isLoading = false;
                    });
            }
        },
        onAdioChanged: function(){
            this.isLoading = true;
            if(this.adioActive){
                stopAdio(this.$store)
                    .then(()=>{
                        this.isLoading = false;
                    });
            }else{
                startAdio(this.$store)
                    .then(()=>{
                        this.isLoading = false;
                    });
            }
        },
        onMeasuringChanged: function(){
            this.isLoading = true;
            if(this.measuringActive){
                stopAll(this.$store)
                    .then(()=>{
                        this.isLoading = false;
                    });
                /*if(this.weatherActive)
                    stopWeather(this.$store);
                if(this.noiseActive)
                    stopNoise(this.$store);
                */
            }else{
                startAll(this.$store)
                    .then(()=>{
                        this.isLoading = false;
                    });
            }
        }
    },
    mounted: function(){
        getStatus(this.$store);
        this.getStatusLoop = setInterval(()=>{
            getStatus(this.$store)
                .then(()=>{
                    this.isLoading = false;
                })
        },5000);
    },
    destroyed: function(){
        if(this.getStatusLoop)
            clearInterval(this.getStatusLoop);
    }
}
</script>




// WEBPACK FOOTER //
// PlayPopover.vue?c8570c9c